// @flow
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 1rem;
  width: ${props => props.width || '100%'};
`;

type Props = {
  width?: string,
  children: any,
};

export const FormGroup = (props: Props) => {
  return <Container style={{ width: props.width }}>{props.children}</Container>;
};
